import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoPageAction, PoPageFilter, PoSearchFilterMode, PoTableAction, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { ProcessoPreCadastroProdutoListaItem } from 'src/app/administrativo/interface/processo-pre-cadastro-produto';
import { FiltroListaPreCadastroProduto } from 'src/app/administrativo/service/filtro/filtro-lista-pre-cadastro-produto';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { UsuarioBase } from 'src/app/interface/usuario';
import { UsuarioLookupService } from 'src/app/service/usuario-lookup-service';

@Component({
  selector: 'app-pre-cadastro-produto-lista',
  templateUrl: './pre-cadastro-produto-lista.component.html',
  styleUrls: ['./pre-cadastro-produto-lista.component.css']
})
export class PreCadastroProdutoListaComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroListaPreCadastroProduto;
  tabelaPrincipalShowMoreDisable: boolean = true;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;
  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Pré-cadastro Produto'},
    ],
  };

  actionPage: Array<PoPageAction> = [
    {label: 'Novo Produto', action: this.novoPreCadastro.bind(this)}
  ]

  usuarioAdvancedFilters: Array<PoDynamicFormField>;
  usuarioColumnsFilters: Array<PoLookupColumn>;
  usuarioFieldFormaterFilters: ((value: UsuarioBase) => string);

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private processoCadastroService: ProcessoCadastroService,
    public usuarioLookupService: UsuarioLookupService,
  ) {
    this.tabelaPrincipalFiltro = new FiltroListaPreCadastroProduto(poStorageService);
    this.tabelaPrincipalFiltro.dados.order = 'NCODIGO desc';
    this.tabelaPrincipalFiltro.dados.CTIPO_IN = 'P';

    this.usuarioAdvancedFilters      = this.usuarioLookupService.getAdvancedFilter();
    this.usuarioColumnsFilters       = this.usuarioLookupService.getColumnsFilter();
    this.usuarioFieldFormaterFilters = this.usuarioLookupService.getFieldFormater;
  }

  @ViewChild('advancedFilterModal', {static: true}) advancedFilterModal!: PoModalComponent;

  ngOnInit(): void {
    this.tabelaPrincipalLoad(true);
  }

  tabelaPrincipalLoad(zerarPaginacao: boolean):void{

    if (zerarPaginacao){
      this.tabelaPrincipalFiltro.dados.page = 1;
      this.tabelaPrincipalItens = [];
    } else {
      this.tabelaPrincipalFiltro.dados.page++;
    }

    this.tabelaPrincipalFiltro.setStorage();

    this.processoCadastroService.getProcCadastroPreProdutoLista(this.tabelaPrincipalFiltro.dados).subscribe({
      next: (lista) => {

        this.tabelaPrincipalShowMoreDisable = !lista.hasNext;

        this.tabelaPrincipalItens = this.tabelaPrincipalItens.concat(lista.items);

       }
    })

  }

  novoPreCadastro(): void{
    this.router.navigateByUrl(`administrativo/pre-cadastro/produto/crud`);
  }

  editarPreCadastro(row: ProcessoPreCadastroProdutoListaItem): void{
    this.router.navigateByUrl(`administrativo/pre-cadastro/produto/crud/${row.NPROCESSOCODIGO}/${row.NCODIGO}`);
  }



  public tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CSTATUS' , width: '10%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '2', color: 'color-01', label: 'Solicitante'},
        { value: '1', color: 'color-03', label: 'Engenharia'},
        { value: '4', color: 'color-04', label: 'Engenharia Negado'},
        { value: '3', color: 'color-05', label: 'Compras'},
        { value: '6', color: 'color-06', label: 'Compras Negado'},
        { value: '5', color: 'color-07', label: 'Controladoria'},
        { value: '8', color: 'color-08', label: 'Controladoria Negado'},
        { value: '9', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'NCODIGO'        , width: '07%', label: 'Código'         , visible: true},
    {property: 'CB1COD'         , width: '10%', label: 'Cd Protheus'    , visible: true},
    {property: 'CB1DESC'        , width: '42%', label: 'Descrição'      , visible: true},
    {property: 'DINCLUSAO'      , width: '07%', label: 'Inclusão'       , visible: true, type: 'date'},
    {property: 'DFINALIZACAO'   , width: '07%', label: 'Finalizado'     , visible: true, type: 'date'},
    {property: 'CUSRID'     , width: '07%', label: 'Cd Usuário'      , visible: false},
    {property: 'CUSRNOME'   , width: '20%', label: 'Usuário'      , visible: true},
  ]

  public tabelaPrincipalActions: Array<PoTableAction> = [
    { label: 'Editar', action: this.editarPreCadastro.bind(this), icon: 'po-icon-edit' }
  ]

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad(true);
    },
    label: 'Aplicar Filtros'
  };
}
